import { Search } from 'lucide-react';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounceCallback } from 'usehooks-ts';
import { Input } from '@/Domain/components/Shared/Input/Input';

interface Props {
  setQuery: (value: string) => void;
}

export const ConversationSearch: React.FC<Props> = ({ setQuery }) => {
  const { t } = useTranslation('inbox_v2');

  const setQueryWithDebounce = useDebounceCallback((value: string) => {
    setQuery(value);
  }, 2000);

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setQueryWithDebounce(value);
  };

  return (
    <div className="animate-fadeIn mb-4.5">
      <Input
        type="search"
        placeholder={t('search')}
        size="sm"
        onChange={handleOnChange}
        startIcon={<Search className="size-4 text-foreground-subtle" />}
      />
    </div>
  );
};
